import React from 'react';
import PropTypes from 'prop-types';
import HomePageAwardListItem from './HomePageAwardListItem';

const HomePageAwardList = (props) => {
    return (
        <section className="container awards">
            <h2>Awards</h2>
            <ul>
                {props.awards
                    .sort((a, b) => a.date.getTime() - b.date.getTime())
                    .reverse()
                    .map((award, i) =>
                        <HomePageAwardListItem key={i} name={award.name} giver={award.giver} url={award.url} />
                    )}
            </ul>
        </section>
    );
};
HomePageAwardList.propTypes = {
    awards: PropTypes.array.isRequired
};

export default HomePageAwardList;



// WEBPACK FOOTER //
// ./src/components/homePage/HomePageAwardList.js